///import { Suspense } from 'react'
import { Hero } from "../Components/LandingComponents/hero";
import { Destacados } from "../Components/LandingComponents/Destacados";
import { Header } from "../Components/LandingComponents/header";
// TODO: use this class with lazy loading
// const HightlightProducts = lazy(() => import('../Components/Menu/HightlightProducts'))
import { About } from "../Components/LandingComponents/about";
import { Footer } from "../Components/LandingComponents/footer";
import React from "react";
export default function LandingPage() {
  return (
    <div>
      <Header />
      <Hero />
      <Destacados />
      <About />
      <Footer />
    </div>
  );
}
